module.exports = __webpack_public_path__ + "static/media/icon／icon_changjianwenti.a7cd1eb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon／icon_changjianwenti.png
// module id = 1776
// module chunks = 0 1